/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class SmartTilePropService implements angular.IComponentOptions {
    templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropService.component.html";
    bindings: any = {
      prop: '=?',
      selectionChanged: '&?', 
      enableServiceCategoryFiltering: '=?'
    }
    controller = class SmartTilePropServiceController {
      static $inject = [
        "meevo.components.common.DataService"
      ];

      public prop: Meevo.Model.SmartTileParameter;
      public selectedService: Model.Service;
      public selectedServiceCategory: Model.ServiceCategory;
      public selectionChanged: Function;
      public serviceCriteria: any;
      public enableServiceCategoryFiltering: boolean = true;

      constructor(protected dataService: Components.BaseClasses.IDataService) { }

      $onInit(): void {
        if (this.prop && this.prop.parameterValue) {
          const separator = ':';
          let displayName = this.prop.parameterDisplayName;
          let shortcut = null;
          try {
            if (displayName.indexOf(separator) > -1) {
              shortcut = displayName.split(separator)[0];
              displayName = displayName.split(separator)[1];
            }
          } catch (e) {

          }
          this.selectedService = {
            id: this.prop.parameterValue,
            displayName: displayName,
            shortcut: shortcut
          };
        }
      }

      onCategoryChanged(): void {
        this.serviceCriteria = { serviceCategoryId: this.selectedServiceCategory ? this.selectedServiceCategory.id : null, };
      }

      onSelectionChanged(): void {
        if (this.selectedService) {
          this.prop.parameterValue = this.selectedService.id;
          this.prop.parameterDisplayName = `${this.selectedService.shortcut}: ${this.selectedService.displayName}`;
        } else {
          this.prop.parameterValue = null;
          this.prop.parameterDisplayName = null;
        }
        this.selectionChanged({
          selection: this.selectedService
        });
      }
    }
  }

  angular.module("meevo.components.controls")
    .component("stpService", new SmartTilePropService());
}
